import React from 'react';
import {FaBed} from "react-icons/fa";
import {MdOutlineBathtub} from "react-icons/md";
import {MdOutlineSquareFoot} from "react-icons/md";
import {MdOutlineChair} from "react-icons/md";
import LocationCards from "./LocationCards";
import './housedetails2aboutproperty.scss'
import MobileLocationMap from './MobileLocationMap';
// import LocationMap from "./LocationMap";

const HouseDetails2AboutProperty = () => {
	return (
		<>
			<section className="HouseDetails2AboutProperty-about-property">
				
				<h2>About the Stay</h2>
				
				<div className="AboutSay">
					<p> This is a private 2BHK offering guests the comfort of a home with essential amenities for a pleasant stay. The space is simple, clean, and well-maintained, suitable for short and long stays. </p>
					
					{/*<ul className="location-list">*/}
					{/*	<li>Solapur Airport - 3.5 km</li>*/}
					{/*	<li>Solapur Passport Office - 5 km</li>*/}
					{/*</ul>*/}
					
					<p><strong>Solapur offers spiritual sites to explore like,</strong></p>
					
					<div className="MapLocation">
					<LocationCards />
					</div>
					<div className="MobileMap">
						<MobileLocationMap />
					</div>
					{/*<LocationMap />*/}
					<ul className="location-list">
						<li>Solapur is famous for its significant textile industry (especially handloom/powerloom Solapuri Chaddars/towels) visit - Pulgam textile or Chatla Textile- 6-8 km away from the property.</li>
						<li>unique local street food - Sangam vada, Mirchi Pakoda</li>
						<li>And dont miss on yummy Shenga Chatni & Kadak bhakri.</li>
					</ul>
					
					<p><strong>If you are non-vegetarian, must visit Chakole Mutton Bhajnalay which is away from 5km.</strong></p>
					
					<p>Enjoy your Solapur tour...🥳</p>
				</div>
				
				<div className="HouseDetails2AboutProperty-property-stats">
					
					<div className="HouseDetails2AboutProperty-stat-card">
						<FaBed className="icon"/>
						<strong>2 Bedrooms</strong>
					</div>
					
					<div className="HouseDetails2AboutProperty-stat-card">
						<MdOutlineBathtub className="icon"/>
						<strong>2 Bathrooms</strong>
					</div>
					
					<div className="HouseDetails2AboutProperty-stat-card">
						<MdOutlineSquareFoot className="icon"/>
						<strong>Spacious Rooms</strong>
					</div>
					
					<div className="HouseDetails2AboutProperty-stat-card">
						<MdOutlineChair className="icon"/>
						<strong>Fully Furnished</strong>
					</div>
				
				</div>
			</section>
		</>
	);
};

export default HouseDetails2AboutProperty;